import {
  APIAccountAssetContext,
  APIAccountContext,
  APIAccountDDIContext,
  APIAccountDeviceContext,
  APIAccountSettingContext,
  APIAccountTrunkContext,
  APIAccountWebhookContext,
  APICodeDeckContext,
  APIEventsContext,
  APINumberPoolContext,
  APIOrganisationChargeContext,
  APIOrganisationContext,
  APIOrganisationMetricsContext,
  APIProductTableContext,
  APIRatingTableContext,
  APIRoleContext,
  APITicketContext,
  APIUserContext,
  APIVoiceRegionContext,
} from "Providers/APIContexts";

import React from "react";

function useAccount() {
  return React.useContext(APIAccountContext);
}

function useOrganisation() {
  return React.useContext(APIOrganisationContext);
}

function useDevice() {
  return React.useContext(APIAccountDeviceContext);
}

function useDDI() {
  return React.useContext(APIAccountDDIContext);
}

function useSetting() {
  return React.useContext(APIAccountSettingContext);
}

function useTrunk() {
  return React.useContext(APIAccountTrunkContext);
}

function useAsset() {
  return React.useContext(APIAccountAssetContext);
}

function useWebhook() {
  return React.useContext(APIAccountWebhookContext);
}

function useRatingTable() {
  return React.useContext(APIRatingTableContext);
}

function useProductTable() {
  return React.useContext(APIProductTableContext);
}

function useCodeDeck() {
  return React.useContext(APICodeDeckContext);
}

function useVoiceRegion() {
  return React.useContext(APIVoiceRegionContext);
}

function useTicket() {
  return React.useContext(APITicketContext);
}

function useOrgCharge() {
  return React.useContext(APIOrganisationChargeContext);
}

function useOrgMetrics() {
  return React.useContext(APIOrganisationMetricsContext);
}

function useNumberPool() {
  return React.useContext(APINumberPoolContext);
}

function useUser() {
  return React.useContext(APIUserContext);
}

function useRole() {
  return React.useContext(APIRoleContext);
}

function useEventGroup() {
  return React.useContext(APIEventsContext);
}

export {
  useAccount,
  useOrganisation,
  useDevice,
  useDDI,
  useSetting,
  useTrunk,
  useWebhook,
  useRatingTable,
  useProductTable,
  useCodeDeck,
  useTicket,
  useOrgCharge,
  useOrgMetrics,
  useUser,
  useNumberPool,
  useRole,
  useEventGroup,
  useAsset,
  useVoiceRegion,
};
